(() => {
  if (window.apolisSpellingConfirmationInstalled) return;
  window.apolisSpellingConfirmationInstalled = true;
  const approved = new WeakMap();
  let pending;
  let openCartAfterConfirmedAdd = false;
  let openCartFormId = '';
  let openCartVariantId = '';
  let openCartProductId = '';
  let openCartComponentId = '';
  let openCartComponent = null;
  let openCartTimeout;
  const dialog = document.createElement('dialog');
  dialog.className = 'apolis-spelling-confirmation';
  dialog.setAttribute('aria-labelledby', 'apolis-spelling-title');
  dialog.innerHTML = '<h2 id="apolis-spelling-title">Double-check your spelling</h2><p>Please double-check your spelling and initials before confirming.</p><div class="apolis-spelling-proof" aria-label="Your personalization"></div><div class="apolis-spelling-actions"><button type="button" class="button" data-confirm>Confirm and add to cart</button><button type="button" class="button button-secondary" data-edit>Keep editing</button></div>';
  document.body.append(dialog);
  // Native Safari's visible viewport can be smaller than the layout viewport.
  function sizeProofViewport() {
    const view = window.visualViewport;
    const width = view ? view.width : document.documentElement.clientWidth;
    const height = view ? view.height : window.innerHeight;
    if (!(width > 32 && height > 32)) return;
    dialog.style.setProperty('--apolis-proof-width', width + 'px');
    dialog.style.setProperty('--apolis-proof-height', height + 'px');
    dialog.style.setProperty('--apolis-proof-left', (view ? view.offsetLeft : 0) + 'px');
    dialog.style.setProperty('--apolis-proof-top', (view ? view.offsetTop : 0) + 'px');
  }
  window.addEventListener('resize', () => { if (dialog.open) sizeProofViewport(); });
  window.visualViewport?.addEventListener('resize', () => { if (dialog.open) sizeProofViewport(); });
  window.visualViewport?.addEventListener('scroll', () => { if (dialog.open) sizeProofViewport(); });
  function snapshot(form) {
    const entries = Array.from(form.elements).filter(el => el.name && !el.disabled && (!['radio', 'checkbox'].includes(el.type) || el.checked)).map(el => [el.name, el.value]);
    const value = name => entries.find(([key]) => key === name)?.[1] || '';
    if (value('properties[customized]') === 'no') return null;
    const lines = entries.filter(([key]) => /^properties\[Line [123]\]$/i.test(key)).map(([, text]) => text);
    const text = (lines.some(line => line.trim()) ? lines : value('properties[customization]').replace(/^Your text:\s*/i, '').split(' | ')).filter(part => part.trim()).join('\n');
    if (!text.trim()) return null;
    // Never build FormData here: formdata listeners belong to the actual submission.
    return {text, signature: JSON.stringify(entries)};
  }
  function show(form, submitter) {
    const state = snapshot(form);
    if (!state) return false;
    pending = {form, submitter, state, focus: document.activeElement};
    dialog.querySelector('.apolis-spelling-proof').textContent = state.text;
    sizeProofViewport();
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-confirm]').focus();
    return true;
  }
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action, location.href).pathname)) return;
    const proof = snapshot(form);
    if (approved.get(form) === proof?.signature) return;
    approved.delete(form);
    if (!snapshot(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    show(form, event.submitter);
  }, true);
  // Keep the exact proof through asynchronous recommendation preflight. Consume it
  // only when the accepted submit reaches the end of propagation.
  window.addEventListener('submit', event => { approved.delete(event.target); });
  function disarmCartOpen() {
    openCartAfterConfirmedAdd = false;
    openCartFormId = '';
    openCartVariantId = '';
    openCartProductId = '';
    openCartComponentId = '';
    openCartComponent = null;
    clearTimeout(openCartTimeout);
  }
  document.addEventListener('cart:error', event => {
    if (!openCartAfterConfirmedAdd) return;
    if (event.target === openCartComponent
      && String(event.detail?.sourceId || '') === openCartFormId) disarmCartOpen();
  });
  document.addEventListener('cart:update', event => {
    if (!openCartAfterConfirmedAdd || event.detail?.data?.source !== 'product-form-component') return;
    if (event.target !== openCartComponent) return;
    const sameProduct = String(event.detail?.data?.productId || '') === openCartProductId;
    if (event.detail?.data?.didError) {
      if (sameProduct && String(event.detail?.sourceId || '') === openCartComponentId) disarmCartOpen();
      return;
    }
    if (!sameProduct || String(event.detail?.sourceId || '') !== openCartVariantId) return;
    disarmCartOpen();
    queueMicrotask(() => {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  });
  dialog.querySelector('[data-edit]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    if (dialog.open) return;
    const previous = pending;
    pending = null;
    if (previous?.focus?.isConnected) previous.focus.focus();
  });
  dialog.querySelector('[data-confirm]').addEventListener('click', () => {
    const current = pending;
    if (!current || !current.form.isConnected) { dialog.close(); return; }
    const fresh = snapshot(current.form);
    if (!fresh || fresh.signature !== current.state.signature) {
      // Variant, quantity or text changed while the proof was open: require a fresh approval.
      dialog.close();
      pending = null;
      if (fresh) queueMicrotask(() => show(current.form, current.submitter));
      return;
    }
    pending = null;
    dialog.close();
    approved.set(current.form, fresh.signature);
    const productForm = current.form.closest('product-form-component');
    openCartFormId = current.form.getAttribute('id') || '';
    openCartVariantId = String(current.form.elements.namedItem('id')?.value || '');
    openCartProductId = String(productForm?.dataset.productId || '');
    openCartComponentId = productForm?.getAttribute('id') || '';
    openCartComponent = productForm;
    openCartAfterConfirmedAdd = !!current.form.closest('product-information')
      && !!openCartComponent && !!openCartFormId && !!openCartVariantId && !!openCartProductId;
    clearTimeout(openCartTimeout);
    if (openCartAfterConfirmedAdd) {
      openCartTimeout = setTimeout(disarmCartOpen, 15000);
    }
    try {
      const submitter = current.submitter;
      if (submitter?.isConnected && submitter.form === current.form && !submitter.disabled) current.form.requestSubmit(submitter);
      else current.form.requestSubmit();
    } catch (error) {
      approved.delete(current.form);
      disarmCartOpen();
      throw error;
    }
  });
})();
